export default __webpack_public_path__ + "static/media/openall.34dc5320.svg";